<template>
    <div id="">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <!-- Botão de Salvar -->
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        ((!isUpdate && permissao.create) || (isUpdate && permissao.update)) &&
                        !grupoIntegracao
                    "
                    class="save-btn"
                    type="button"
                    @click="saveGrupoProduto"
                    :disabled="isSaving"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="page page-container">
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <v-input
                            :id="generateId(1)"
                            ref="idErpInput"
                            v-model="gp.idgrupoprodutoerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                            required
                            tooltipLabel="cod-ref"
                            :invalid="!gp.idgrupoprodutoerp"
                            :disabled="grupoIntegracao"
                        />
                    </div>
                    <div class="column is-6">
                        <v-input
                            v-model="gp.descricao"
                            :id="generateId(2)"
                            :placeholder="'descricao-do-gp-placeholder'"
                            :maxlength="50"
                            :title="'descricao-do-grupo-produto'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!gp.descricao"
                            ref="descricaoInput"
                            required
                            tooltipLabel="info-descricao-generica"
                            :disabled="grupoIntegracao"
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(3)"
                            ref="empresaSelect"
                            :searchable="false"
                            :options="empresas"
                            v-model="empresa"
                            class="no-clear"
                            :required="true"
                            title="empresa"
                            :invalid="!empresa"
                            tooltipLabel="info-empresa-generica"
                            :disabled="grupoIntegracao"
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(4)"
                            ref="ed"
                            v-model="situacaoSelected"
                            title="situacao"
                            :required="true"
                            :options="situacaoSelect"
                            :searchable="false"
                            :disabled="!isUpdate || grupoIntegracao"
                            tooltipLabel="info-situacao-generica"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoProdutoService from '@/services/GrupoProdutoService';
import GrupoProdutoValidation from '@/services/validations/GrupoProdutoValidation';
import Message from '@/models/Message';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged && this.flag === 0) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    watch: {
        gp: {
            deep: true,
            handler: function () {
                this.isChanged = true;
            },
        },
    },
    data() {
        return {
            grupoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('GRUPOPRODUTO'),
            isSaving: false,
            gp: {
                idgrupoprodutoerp: null,
                idempresa: null,
                situacao: 1,
            },
            editable: false,
            title: '',
            msgs: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' %',
                precision: 2,
                masked: false,
            },
            situacaoSelected: { label: 'Ativo', id: 1 },
            situacaoSelect: [
                { label: 'Inativo', id: 0 },
                { label: 'Ativo', id: 1 },
            ],
            isUpdate: false,
            // @84561 - Adicionado variável para verificar a origem da rota
            // Esta variável é utilizada sempre que for verificado se a origem da rota é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
            empresas: [{ id: 0, label: this.$t('todos').toUpperCase() }],
            empresa: { id: 0, label: this.$t('todos').toUpperCase() },
            isChanged: false,
            flag: 0,
        };
    },
    created() {
        if (this.gp != null && this.gp != {}) {
            this.editable = true;
        }

        this.service = new GrupoProdutoService(this.$http, this.$router);
        this.validation = new GrupoProdutoValidation(this.msgs);

        this.permissao = this.isVenda
            ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-grupo')
            : this.hasPermissionAccess('promotor', 'cadastros', 'grupos');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'grupo-produto' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'grupo-produto' },
                });
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
            this.loadEmpresas();
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}`, label: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}`, label: e.rsocial });
                });
            }
        },
        carregarDados(id) {
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.gp = body.content;
                        this.title = this.gp.descricao;
                        // @84561 - Feito desta forma pois o filter não estava retornando a empresa
                        if (this.gp.idempresa != 0) {
                            for (let e of this.empresas) {
                                if (e.id === this.gp.idempresa) {
                                    this.empresa = { id: e.id, label: e.label };
                                }
                            }
                        } else {
                            this.empresa = {
                                id: 0,
                                label: this.$t('todos').toUpperCase(),
                            };
                        }
                        this.situacaoSelected = this.situacaoSelect
                            ? this.situacaoSelect.filter((s) => s.id == this.gp.situacao)[0]
                            : situacaoSelected;
                    } else {
                        this.$router.push({
                            name: this.isVenda ? 'produtos-new-grupo' : 'pro-produto-grupo-new',
                        });
                    }
                })
                .catch((e) => {
                    console.error('[TURNO] Erro ao carregar grupo.', e);
                    this.msgs.push(new Message('error', 'msg-erro-carregar-grupo', true));
                })
                .finally((_) => {
                    this.isChanged = false;
                });
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.gp.situacao = situacao.id;
                this.situacaoSelect = situacao;
            }
        },
        saveGrupoProduto() {
            this.flag = 1;
            this.isSaving = true;
            this.gp.idempresa = this.empresa.id;
            this.gp.descricao = this.mapTosave(this.gp.descricao);
            this.gp.situacao = this.situacaoSelected.id;
            if (this.validation.validate(this.gp, this.$refs)) {
                this.service
                    .save(this.gp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-grupo-produto-salvo';
                            if (this.gp.id) {
                                msg = 'msg-grupo-produto-editado';
                            }
                            this.gp = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            this.isChanged = false;
                            this.redirectToPage();
                        } else {
                            this.isSaving = false;

                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: this.gp.idgrupoprodutoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        this.flag = 0;
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
        redirectToPage() {
            this.isChanged = false;
            let tempTela = this.isVenda ? 'ven-produto-grupo' : 'grupos';
            let tempQuery = null;

            if (this.$route.query.tela == 'motivo-atendimento') {
                tempTela = 'ven-motivo-atendimento-edit';
                tempQuery = { abaSelecionada: 'produtosPesquisaMercado' };
            }

            const route = {
                name: tempTela,
                params: { id: this.$route.query['id'], name: this.$route.query.name },
                query: tempQuery,
            };
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    padding: 20px 20px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 80px;
    height: auto;

    .novo-grupo-produto {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.novo-grupo-produto .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.novo-grupo-produto .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input {
        width: 66%;
    }

    .comissao-input,
    .situacao-input {
        width: 33%;
    }

    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}

h1.title {
    margin-right: 540px;
}
</style>
